import { toZonedTime } from "date-fns-tz";
import { format } from "date-fns";
import { DATE_PATTERN_SIMPLE } from "./formatDate";

export function formatToISO8601(dates: string | string[]): string | string[] {
  if (typeof dates === "string") {
    const date = toZonedTime(dates, "UTC");

    if (isNaN(date.getTime())) {
      throw new Error("Invalid date string provided");
    }

    return format(date, DATE_PATTERN_SIMPLE);
  }

  // Handle array of dates
  return dates.map(dateString => {
    const date = toZonedTime(dateString, "UTC");

    if (isNaN(date.getTime())) {
      throw new Error("Invalid date string provided in array");
    }

    return format(date, DATE_PATTERN_SIMPLE);
  });
}
